"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require("./create");
exports.Urls = create_1.Urls;



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-routing/dist/index.js
// module id = B7EN
// module chunks = 2